import { render, staticRenderFns } from "./download-apk-modal.component.vue?vue&type=template&id=0a8e6830"
var script = {}
import style0 from "./download-apk-modal.component.vue?vue&type=style&index=0&id=0a8e6830&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports